import React, { useState } from 'react'
import moment from 'moment';

function DownloadfileModal({ data }: any) {
    const [start_date, setStartDate] = useState(moment().subtract(30, 'days').toDate().getTime());
    const [end_date, setEndDate] = useState(moment().toDate().getTime());
    const [loading, setLoading] = useState(false);

    const download = async () => {
        try {
            setLoading(true);
            await data(start_date, end_date);
        } finally {
            setLoading(false);
        }
    }

    return (
        <div
            className="modal fade"
            id="exampleModal"
            tabIndex={-1}
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h4 className="modal-title" id="exampleModalLabel">
                            <i className="fas fa-file-excel text-success me-2"></i>
                            Export Data (.xlsx)
                        </h4>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            id="closeModal"
                        ></button>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-md-6">
                                <label className="form-label">Date From</label>
                                <input
                                    type="date"
                                    max={moment().format('YYYY-MM-DD')}
                                    defaultValue={moment().subtract(30, 'days').format('YYYY-MM-DD')}
                                    className="form-control"
                                    onChange={(e: any) => setStartDate(e.target.valueAsNumber || moment(e.target.value).valueOf())}
                                />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label">Date To</label>
                                <input
                                    type="date"
                                    max={moment().format('YYYY-MM-DD')}
                                    defaultValue={moment().format('YYYY-MM-DD')}
                                    className="form-control"
                                    onChange={(e: any) => setEndDate(e.target.valueAsNumber || moment(e.target.value).valueOf())}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            data-bs-dismiss="modal"
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary-button"
                            onClick={download}
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <i className="fa fa-spinner fa-spin me-1"></i>
                                    Exporting...
                                </>
                            ) : (
                                <>
                                    <i className="fas fa-file-excel me-1"></i>
                                    Export (.xlsx)
                                </>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DownloadfileModal
